<template>
  <v-row class="ma-0 white location-container">
    <v-col cols="12" class="pa-0">
      <v-row no-gutters>
        <v-col cols="12" v-if="computed_location_details">
          <v-row no-gutters class="bottom-border">
            <v-col cols="12" class="pb-0 d-flex flex-column justify-space-between">
              <v-row no-gutters class="pl-0 pr-5 pt-4">
                <v-col cols="11">
                  <div class="font-weight-bold">
                    {{ computed_location_details.FullName }}
                    <v-chip
                      dark
                      x-small
                      class="ml-2 mb-1"
                      v-if="computed_location_details.LocationCategory"
                      color="primaryGrey"
                    >
                      {{ computed_location_details.LocationCategory }}
                    </v-chip>
                  </div>
                  <div v-if="computed_location_details.LocationAddress1">
                    {{ computed_location_details.LocationAddress1 }}
                  </div>
                  <div v-if="computed_location_details.Latitude" class="d-flex mt-1 text-caption primaryGrey--text">
                    <div>
                      <v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon
                      >{{ computed_location_details.Latitude }}
                    </div>
                    <div class="ml-3">
                      <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon
                      >{{ computed_location_details.Longitude }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="1" class="text-right">
                  <v-icon>{{ computed_location_details.IsWatchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                </v-col>
              </v-row>
              <v-row no-gutters class="pl-0 pr-5 pt-4 info-container">
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Total Assets On Location</div>
                  {{ total_assets }}
                </v-col>
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Fluid Assets</div>
                  <div class="primaryDark--text">
                    {{ device_status["Fluid"] }}
                    <span class="primaryGrey--text" style="font-size: 10px; color: #a1c7e2"
                      >{{ get_percentage(total_assets, device_status["Fluid"]) }}%</span
                    >
                  </div>
                </v-col>
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Static Assets</div>
                  <div class="primaryDark--text">
                    {{ device_status["Static"] }}
                    <span class="primaryGrey--text" style="font-size: 10px; color: #a1c7e2"
                      >{{ get_percentage(total_assets, device_status["Static"]) }}%</span
                    >
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="pl-0 pr-5 mt-2 info-container">
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Rate of Flow</div>
                  <div>
                    {{ $percentage(computed_location_details.FlowRate) }}
                  </div>
                </v-col>
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">% Of Fleet At This Location</div>
                  <div>{{ get_percentage(total_fleet_assets, total_assets) }}%</div>
                </v-col>
                <v-col cols="4" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Avg. Stay Duration</div>
                  <div>
                    {{ computed_location_details.Utilisation | timeSince }}
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="pl-0 pr-5 mt-2 pb-4 info-container">
                <v-col cols="8" class="pr-4">
                  <div style="font-size: 14px; font-weight: bold">Comments</div>
                  <div>
                    {{ $emptyCheck(computed_location_details.Comment) }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row class="pt-5 pb-3" no-gutters>
                    <v-col cols="auto" class="px-2 mr-2 text-subtitle-1 font-weight-bold dashboard_tab tab-highlighted"
                      >Stay Duration</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="pb-8">
                  <ColumnChartVT
                    xlabel="Static Stay Time"
                    ylabel="Number of Assets"
                    :chartData="stay_duration"
                  ></ColumnChartVT>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <div class="mt-5 mb-1 text-subtitle-1 font-weight-bold">Devices</div>
              <DataTableVT
                :headers="page_content.devices_table"
                :items_list="devices_list"
                :no_search="no_search"
                no_pagination="true"
                print="true"
              />
              <div class="mt-5 mb-1 text-subtitle-1 font-weight-bold">Journeys</div>
              <DataTableVT
                :headers="page_content.journeys_table"
                :items_list="journeys_list"
                :no_search="no_search"
                no_pagination="true"
                print="true"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DataTableVT from "../components/DataTableVT";
import ColumnChartVT from "../components/ColumnChartVT";
import { axios_get } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/locations.js";

export default {
  props: ["location_detail"],
  watch: {},
  name: "POISnapshot",
  components: {
    DataTableVT,
    ColumnChartVT,
  },
  data: function () {
    return {
      max_inactive_assets: 0,
      device_status: {
        Fluid: 0,
        Static: 0,
      },
      filter_conditions: {},
      primary_filter_conditions: "",
      locationId: null,
      flat: true,
      hide_legends: true,
      network_error: false,
      devices_list: [],
      device_data: [],
      current_position: {},
      current_battery_icon: "battery-full",
      has_coordinates: false,
      chartData: [],
      location_details: {},
      watchlisted_devices: [],
      line_chart_data: [],
      poi_dashboard: "duration",
      stay_duration: [],
      journeys_list: [],
      no_search: true,
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
    };
  },
  mounted() {
    this.page_content = content;
    this.asset_arrival_week = "1";
    this.line_chart_data = [
      ["Weekly Stats", "Inactive Assets", { role: "tooltip", type: "string", p: { html: true, role: "tooltip" } }],
    ];
    this.stay_duration = [["Assets stay duration over time", "Fluid Assets", "Static Assets", { role: "annotation" }]];
    this.on_load_fetch_data();
  },
  methods: {
    get_percentage(total, val) {
      return Math.round((val / total) * 10000) / 100;
    },
    open_details(item) {
      this.$router.push("/device/" + item["DeviceID"]);
    },
    apply_filters(filters) {
      this.filter_conditions = filters;
      this.filter_list("All");
    },
    get_color_indicator(value, day) {
      let current_value = (value && value[day]) || 0;
      let filtered_color = this.arrival_time_color.filter((elem) => {
        return current_value < elem.max && current_value >= elem.min;
      });
      return (filtered_color && filtered_color[0] && filtered_color[0].color) || "restingOutline";
    },
    async filter_list(filter) {
      if (filter) this.primary_filter_conditions = filter;
      var params = {};
      const keys =
        (this.filter_conditions &&
          this.filter_conditions.checkbox &&
          Object.keys(this.filter_conditions["checkbox"])) ||
        [];
      keys.forEach((key) => {
        if (this.filter_conditions["checkbox"][key].length > 0)
          params[key] = this.filter_conditions["checkbox"][key].toString();
      });
      this.network_error = false;
      let response = await axios_get(tracking.fetch_devices_at_POI, { id: this.locationId });
      let range_filter = {};
      let range_keys =
        this.filter_conditions && this.filter_conditions["range"] && Object.keys(this.filter_conditions["range"]);
      for (let i = 0; i < (range_keys && range_keys.length) || 0; i++) {
        let temp = range_keys[i].split("_");
        let field = temp[1];
        range_filter[temp[0]] = range_filter[temp[0]] || {};
        range_filter[temp[0]][field] = this.filter_conditions["range"][range_keys[i]];
      }
      this.devices_list = response.filter((elem) => {
        let filtered = true;
        let filter = Object.keys(range_filter);
        for (let i = 0; i < filter.length; i++) {
          if (!(range_filter[filter[i]]["min"] == 0 && range_filter[filter[i]]["max"] == 0))
            filtered =
              filtered &&
              elem[filter[i]] >= range_filter[filter[i]]["min"] &&
              elem[filter[i]] <= range_filter[filter[i]]["max"];
        }
        return filtered;
      });
    },
    clear_filters: function () {
      this.filter_conditions = {};
      this.filter_list("All");
    },
    format_graph_data(response) {
      let assets_stay_duration = {
        Fluid: [],
        "Static <= 1 Week": [],
        "Static <= 1 Month": [],
        "Static > 1 Month": [],
      };
      for (let i = 0; i < response.length; i++) {
        this.device_status[response[i]["DeviceStatus"]]++;
        if (response[i]["StayDuration"] < 72) {
          assets_stay_duration["Fluid"].push(response[i]);
        } else if (response[i]["StayDuration"] >= 72 && response[i]["StayDuration"] <= 168) {
          assets_stay_duration["Static <= 1 Week"].push(response[i]);
        } else if (response[i]["StayDuration"] > 168 && response[i]["StayDuration"] <= 720) {
          assets_stay_duration["Static <= 1 Month"].push(response[i]);
        } else if (response[i]["StayDuration"] > 720) {
          assets_stay_duration["Static > 1 Month"].push(response[i]);
        }
      }
      for (const property in assets_stay_duration) {
        let active = assets_stay_duration[property].filter((elem) => elem["DeviceStatus"] == "Fluid");
        let inactive = assets_stay_duration[property].filter((elem) => elem["DeviceStatus"] == "Static");
        this.stay_duration.push([
          property,
          active.length || 0,
          inactive.length || 0,
          active.length || inactive.length || 0,
        ]);
      }
    },
    async on_load_fetch_data() {
      this.location_detail ? this.get_device_data() : this.get_location_data();
    },
    async get_device_data() {
      this.network_error = false;
      this.locationId = this.$route.params.locationId || (this.location_detail && this.location_detail.LocationID);
      this.get_journeys_data();
      let response = await axios_get(tracking.fetch_devices_at_POI, { id: this.locationId });
      this.format_graph_data(response);
      this.devices_list = response;
    },
    async get_journeys_data() {
      this.network_error = false;
      let response = await axios_get(tracking.get_journeys_data);
      this.journeys_list = this.filter_journeys_data(response);
    },
    async get_location_data() {
      this.network_error = false;
      this.locationId = this.$route.params.locationId || (this.location_detail && this.location_detail.LocationID);
      if (this.$route.params.locationId) {
        this.$store.commit("clear_search");
        this.no_search = false;
      }

      this.get_journeys_data();
      let location_res = await axios_get(tracking.get_location_details, { locationId: this.locationId });
      let watchlist_res = await axios_get(tracking.get_watchlisted_locations);
      let device_data_res = await axios_get(tracking.fetch_devices_at_POI, { id: this.locationId });
      let stats_res = await axios_get(tracking.get_location_stats);
      this.location_details = location_res[0];
      var stats_data = stats_res.filter((elem) => elem.FullName == this.location_details.FullName)[0];
      this.format_graph_data(device_data_res);
      this.devices_list = device_data_res;
      if (this.location_details) {
        this.watchlisted_devices = watchlist_res.map((elem) => {
          return elem.LocationID.toString();
        });
        this.location_details["IsWatchlisted"] =
          this.watchlisted_devices.indexOf(this.locationId.toString()) == -1 ? false : true;
        this.location_details["FlowRate"] = stats_data["FlowRate"];
        this.location_details["Utilisation"] = stats_data["Utilisation"];
        this.location_details["TotalAssets"] = this.devices_list.length;
        this.$store.commit("update_page_title", `POI / ${this.location_details.FullName}`);
      }
    },
    filter_journeys_data(response) {
      return response.filter((elem) => {
        return elem.OriginID == this.locationId || elem.DestinationID == this.locationId;
      });
    },
    filter_journeys_list() {
      return this.devices_list.filter((elem) => elem.DeviceID == this.deviceId);
    },
  },
  computed: {
    location_devices: function () {
      return this.devices_list.filter((elem) => {
        return elem.FullName == this.location_details.FullName;
      });
    },
    total_fleet_assets: function () {
      return (this.$store.state.devices && this.$store.state.devices.length) || 0;
    },
    computed_location_details: {
      get: function () {
        return this.location_detail || this.location_details;
      },
    },
    get_center: function () {
      return new window.google.maps.LatLng(
        this.computed_location_details.Latitude,
        this.computed_location_details.Longitude
      );
    },
    total_assets: function () {
      return this.device_status["Fluid"] + this.device_status["Static"];
    },
  },
};
</script>

<style lang="scss" scoped>
div.bottom-border {
  border-bottom: 1px solid var(--v-restingOutline-base);
}
div.tab-highlighted {
  border-bottom: 4px solid var(--v-borderDark-base);
}
div.dashboard_tab {
  cursor: pointer;
}
div.right-border {
  border-right: 1px solid var(--v-restingOutline-base);
}
div.add-border {
  border: 1px solid var(--v-restingOutline-base);
}
div.fixd-tile {
  height: 8px;
  width: 38px;
}

.location_stats div.d-flex div {
  width: 50%;
}

div.fixd-legend-tile {
  height: 15px;
  width: 50px;
}

.location-container .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}

div.graph-sub-heading {
  color: var(--v-primaryGrey-base);
  font-size: 0.5rem;
  font-weight: bold;
}
</style>
